export function PoliciesPage() {
  return (
    <div className="page policy-page">
      <header className="page-header">
        <span className="eyebrow">使用政策</span>
        <h1>隱私權、使用條款與社群規則</h1>
        <p>營運者：iLoveSing 團隊 · 聯絡與檢舉：skybrainingjimmy@gmail.com</p>
      </header>

      <nav className="policy-nav" aria-label="本頁章節">
        <a href="#privacy">隱私權</a>
        <a href="#terms">使用條款</a>
        <a href="#community">社群規則</a>
        <a href="#report">檢舉</a>
      </nav>

      <section id="privacy" className="policy-section">
        <h2>隱私權政策</h2>
        <h3>我們蒐集什麼</h3>
        <p>
          登入時蒐集 Google sub、Email、顯示名稱與頭像；另保存本站 Session、安全紀錄、作品設定及你主動寄出的檢舉郵件。
          Email 不會顯示在公開作品。
        </p>
        <h3>用途與第三方</h3>
        <p>
          資料只用於登入、作品歸屬、分享、安全與內容治理。Cloudflare 提供網站、Worker 與 D1；Google
          提供登入；YouTube 提供影片、播放器與 API，資料可能於境外處理。
        </p>
        <h3>保存與你的權利</h3>
        <p>
          Session 固定 7 天，登出、刪除帳號或停權時立即撤銷。刪除帳號採匿名化：清除 Google sub、Email
          與頭像，公開名稱改為「匿名使用者」，保留匿名作品與來源鏈。你可以聯絡我們請求查詢、更正、停止利用或匿名化。
        </p>
      </section>

      <section id="terms" className="policy-section">
        <h2>使用條款</h2>
        <ul>
          <li>使用者必須年滿 13 歲，並在登入前同意本政策、本站條款與 YouTube 服務條款。</li>
          <li>本站只保存 Video ID、連結與節點設定；不下載、重製或宣稱擁有 YouTube 原影片。</li>
          <li>YouTube 嵌入不代表取得公開演出、KTV、活動商用或其他另行需要的授權。</li>
          <li>影片可能因刪除、隱私、嵌入限制、廣告、網路或平台政策而無法播放；本站不保證切點精準或持續可用。</li>
        </ul>
        <p>
          <a href="https://www.youtube.com/t/terms" target="_blank" rel="noreferrer">
            YouTube 服務條款
          </a>
          {' · '}
          <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">
            Google 隱私權政策
          </a>
        </p>
      </section>

      <section id="community" className="policy-section">
        <h2>iLoveSing 社群規則</h2>
        <p>
          公開作品必須同時符合本站規則與 YouTube 社群規範；規則衝突時採較嚴格標準。不得透過作品標題、說明、節點名稱或影片散布：
        </p>
        <ul>
          <li>色情、性剝削、未經同意性影像或兒少危害。</li>
          <li>重大暴力、仇恨、騷擾、威脅或個資揭露。</li>
          <li>詐騙、非法商品、惡意程式或其他違法內容。</li>
          <li>未經允許重製歌詞／字幕、冒充原作者或誤導已取得商用授權。</li>
        </ul>
        <p>
          權利人檢舉成立時可隱藏作品；三次成立的版權違規可停權。重大暴力、性剝削或急迫危險可直接停權。
          一般社群處置不提供站內申訴；依法提出的版權回復通知或主管機關文件仍可由聯絡信箱受理。
        </p>
      </section>

      <section id="report" className="policy-section">
        <h2>如何檢舉</h2>
        <p>
          在公開分享頁點「檢舉本站作品」，郵件會預填作品與 YouTube 網址。請補上類別、相關時間點與說明後寄至{' '}
          <a href="mailto:skybrainingjimmy@gmail.com">skybrainingjimmy@gmail.com</a>。
        </p>
        <p>一般案件目標為 50 小時內確認收件、100 小時內完成初步處理；緊急兒少或人身危險案件會優先處理。</p>
      </section>
      <p className="legal-note">版本：2026-07-29。正式公開營運前仍應由適格法律專業人員依實際所在地覆核。</p>
    </div>
  )
}

